module.exports = __webpack_public_path__ + "static/media/HarlemDoggieDaySpa.dccb9760.ico";